<template>
  <div class="body_left">
    <div class="body_left_top">
      <div class="body_left_top_img"><img :src="this.$store.state.userInfo.avatar" /></div>
      <div class="body_left_top_name">{{this.$store.state.userInfo.nickname}} <div class="gender male" v-if="this.$store.state.userInfo.gender==1"><i class="el-icon-male"></i></div><div class="gender female" v-if="this.$store.state.userInfo.gender==0"><i class="el-icon-female"></i></div></div>
      <div class="body_left_top_ip">IP 深圳</div>
      <div class="body_left_top_msg"><div>概要：{{this.$store.state.userInfo.sign}}</div></div>
      <div class="body_left_top_list">
        <div class="list_item">
          <div class="list_item_title">人気度</div>
          <div class="list_item_msg">{{num.charmNum}}</div>
        </div>
        <div class="list_item">
          <div class="list_item_title">フォロー中</div>
          <div class="list_item_msg">{{num.followNum}}</div>
        </div>
        <div class="list_item">
          <div class="list_item_title">フォロワー</div>
          <div class="list_item_msg">{{num.followerNum}}</div>
        </div>
      </div>
    </div>
    <div class="body_left_btn">
      <router-link :to="'/pagehome'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='home'}">
          <div class="item_vectorgraph home"><img src="@/assets/imgs/home_icon.png"/></div>
          <div class="item_title">我的資料</div>
        </div>
      </router-link>
      <div class="body_left_btn_item">
        <div class="item_vectorgraph"><img src="@/assets/imgs/notice_icon.png"/></div>
        <div class="item_title" @click="noticeStateFun()">プッシュ通知</div>
        <div class="nones" v-bind:class="{item_notice:this.likeNoticeNum+this.commentNoticeNum!=0}">{{likeNoticeNum+commentNoticeNum}}</div>
        <div class="item_son" v-if="noticeState">
          <router-link :to="'/likeNotice'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='likeNotice'}">
              <div class="item_vectorgraph likeNotice"><img src="@/assets/imgs/likenotice_icon.png"/></div>
              <div class="item_title">「いいね!」通知</div>
              <div class="nones" v-bind:class="{item_notice:this.likeNoticeNum!=0}" v-if="likeNoticeNum">{{likeNoticeNum}}</div>
            </div>
          </router-link>  
          <router-link :to="'/commentNotice'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='commentNotice'}">
              <div class="item_vectorgraph commentNotice"><img src="@/assets/imgs/commentnotice_icon.png"/></div>
              <div class="item_title">コメント通知</div>
              <div class="nones" v-bind:class="{item_notice:this.commentNoticeNum!=0}" v-if="commentNoticeNum">{{commentNoticeNum}}</div>
            </div>
          </router-link>
          <!-- <router-link :to="'/friendUpdates'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='friendUpdates'}">
              <div class="item_vectorgraph friendUpdates"><img src="@/assets/imgs/friendupdates_icon.png"/></div>
              <div class="item_title">友達の動態</div>
            </div>
          </router-link>
          <router-link :to="'/systemNotice'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='systemNotice'}">
              <div class="item_vectorgraph systemNotice"><img src="@/assets/imgs/systemnotice_icon.png"/></div>
              <div class="item_title">お知らせ</div>
            </div>
          </router-link> -->
        </div>
      </div>
      <div class="body_left_btn_item">
        <div class="item_vectorgraph"><img src="@/assets/imgs/articlemanage_icon.png"/></div>
        <div class="item_title" @click="manageStateFun()">コンテンツ管理</div>
        <div class="item_son" v-if="manageState">
          <router-link :to="'/articleManage'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl == 'articleManage'}">
              <div class="item_vectorgraph articleManage"><img src="@/assets/imgs/articlemanage_icon.png"/></div>
              <div class="item_title">記事管理</div>
            </div>
          </router-link>
          <router-link :to="'/videoManage'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl == 'videoManage'}">
              <div class="item_vectorgraph videoManage"><img src="@/assets/imgs/videomanage_icon.png"/></div>
              <div class="item_title">発見動画</div>
            </div>
          </router-link>
          <router-link :to="'/postManage'">
            <div class="item_son_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl == 'postManage'}">
              <div class="item_vectorgraph postManage"><img src="@/assets/imgs/postmanage_icon.png"/></div>
              <div class="item_title">発見管理</div>
            </div>
          </router-link>
        </div>
      </div>
      <router-link :to="'/collect'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='collect'}">
          <div class="item_vectorgraph collect"><img src="@/assets/imgs/collect_icon.png"/></div>
          <div class="item_title">お気に入り</div>
        </div>
      </router-link>
      <router-link :to="'/history'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='history'}">
          <div class="item_vectorgraph history"><img src="@/assets/imgs/history_icon.png"/></div>
          <div class="item_title">り覧履歴</div>
        </div>
      </router-link>
      <router-link :to="'/chat'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='chat'}">
          <div class="item_vectorgraph chat"><img src="@/assets/imgs/systemnotice_icon.png"/></div>
          <div class="item_title">チャット</div>
          <div class="item_notice_s" v-if="chatNum!=0">{{chatNum}}</div>
        </div>
      </router-link>
      <router-link :to="'/comment'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='comment'}">
          <div class="item_vectorgraph comment"><img src="@/assets/imgs/commentnotice_icon.png"/></div>
          <div class="item_title">コメント</div>
        </div>
      </router-link>
      <router-link :to="'/like'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='like'}">
          <div class="item_vectorgraph like"><img src="@/assets/imgs/likenotice_icon.png"/></div>
          <div class="item_title">いいね</div>
        </div>
      </router-link>
      <router-link :to="'/help'">
        <div class="body_left_btn_item" v-bind:class="{body_left_btn_item_click:this.$store.state.routerUrl=='help'}">
          <div class="item_vectorgraph help"><img src="@/assets/imgs/help_icon.png"/></div>
          <div class="item_title">帮助</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    props:['num'],
    data () {
      return {
        noticeState: true,
        manageState: true,
        userInfo: null,
        likeNoticeNum: 0,
        commentNoticeNum: 0,
        chatNum: 0
      }
    },
    created () {
      this.userInfo = this.$store.state.userInfo
      this.getNotice()
    },
    watch:{
      "$store.state.routerUrl":{
        handler:function(newval){
          if(newval == 'likeNotice'){
            this.likeNoticeNum = 0
          }else if(newval == 'commentNotice'){
            this.commentNoticeNum = 0
          }
        }
      },
      "$store.state.likeMsg":{
        handler:function(newval,oldval){
          this.getNotice()
        }
      },
      "$store.state.commentMsg":{
        handler:function(newval,oldval){
          this.getNotice()
        }
      },
      "$store.state.msgList":{
        handler:function(newval,oldval){
          this.getNotice()
        }
      },
    },
    methods: {
      leftFun(id){
        if(id==1){
          this.$router.push('/pagehome')
        }else if(id== 2){
          this.$router.push('/likeNotice')
        }
      },
      noticeStateFun(){
        if(this.noticeState){
          this.noticeState = false
        }else{
          this.noticeState = true
        }
      },
      manageStateFun(){
        if(this.manageState){
          this.manageState = false
        }else{
          this.manageState = true
        }
      },
      getNotice(){
        this.likeNoticeNum = 0
        if(this.$store.state.routerUrl!='likeNotice'){
          if(this.$store.state.likeMsg!=undefined&&this.$store.state.likeMsg&&this.$store.state.likeMsg[this.userInfo.id]){
            for(let i = 0;i<this.$store.state.likeMsg[this.userInfo.id].length;i++){
              if(this.$store.state.likeMsg[this.userInfo.id][i].read === undefined){
                this.likeNoticeNum ++
              }
            }
          }
        }
        this.commentNoticeNum = 0
        if(this.$store.state.routerUrl!='commentNotice'){
          if(this.$store.state.commentMsg!=undefined&&this.$store.state.commentMsg&&this.$store.state.commentMsg[this.userInfo.id]){
            for(let i = 0;i<this.$store.state.commentMsg[this.userInfo.id].length;i++){
              if(this.$store.state.commentMsg[this.userInfo.id][i].read === undefined){
                this.commentNoticeNum ++
              }
            }
          }
        }
        let chatList = []
        if(this.$store.state.chatList!=[]&&this.$store.state.chatList){
          chatList = this.$store.state.chatList[this.$store.state.userInfo.id]
        }
        let notice = 0
        if(chatList){
          chatList.forEach(item =>{
            let othersList = []
            if(this.$store.state.msgList){
              othersList = this.$store.state.msgList[item.id]
            }
            if(othersList){
              othersList.forEach(item =>{
                if(item.from == this.$store.state.userInfo.id){
                  if(item.read == undefined){
                    notice ++ 
                  }
                }
              })
            }
          })
        }
        this.chatNum = notice
      }
    },
  }
</script>

<style scoped>
  @import 'index.css';
</style>